import sy from '~/styles';
import {Text} from '~/components/controls';

import {getHighlightRange} from '../helper';
import PropTypes from 'prop-types';

const HighlightText = ({text, highlight}) => {
  const {start, end} = getHighlightRange(text, highlight);

  return (
    <>
      {start === -1 ? (
        <Text>{text}</Text>
      ) : (
        <>
          {start > 0 && <Text>{text.substring(0, start)}</Text>}
          <Text style={sy.mediumBold}>{text.substring(start, end)}</Text>
          <Text>{text.substring(end)}</Text>
        </>
      )}
    </>
  );
};
HighlightText.propTypes = {
  text: PropTypes.any,
  highlight: PropTypes.any,
};


export default HighlightText;
